import { createSlice } from '@reduxjs/toolkit';
interface IStyleReviewState {
    lastReviewStyleId: null | String;
}
const initialState: IStyleReviewState = {
    lastReviewStyleId: null,
};
// Action =====================================================
const styleReviewSlice = createSlice({
    name: 'style',
    initialState,
    reducers: {
        setLastReviewStyleId: (state, action) => {
            state.lastReviewStyleId = action.payload;
        },
    },
});

// Selector =====================================================
export const { setLastReviewStyleId } = styleReviewSlice.actions;
// Reducer=====================================================
const styleReviewReducer = styleReviewSlice.reducer;
export default styleReviewReducer;
